import { render, staticRenderFns } from "./NewSystem.html?vue&type=template&id=08378a34&external"
import script from "./NewSystem.vue?vue&type=script&lang=js"
export * from "./NewSystem.vue?vue&type=script&lang=js"
import style0 from "./NewSystem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports